// NoChartData.jsx
import React from 'react'
import { FormattedMessage } from 'react-intl'

import styles from '../../../../css/charts.module.css'

function NoChartData () {
  return (
    <div className={styles.noChartData}>
      <FormattedMessage
        id='chart.noData'
        defaultMessage='No data for time period'
        description='No data for time period'
        tagName='h3'
      />
    </div>
  )
}

export default NoChartData
